var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProficiencyFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "content",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke-miterlimit: 10;\n      }\n\n      .st0, .st1 {\n        fill: none;\n      }\n\n      .st0, .st2 {\n        stroke: #000;\n      }\n\n      .st2 {\n        fill: #999;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M88.5,103.4h2c0-2.7,2-4.9,4.4-4.9V10.8c-2.5,0-4.4-2.2-4.4-4.9-13-.6-26.5-1-40.5-1s-27.5.4-40.5,1c0,.3,0,2.1-1.3,3.4-.5.6-1.1,1-1.8,1.2-.5.2-1,.2-1.3.2v87.6c.3,0,.8,0,1.3.2.7.2,1.3.7,1.8,1.2,1.3,1.4,1.3,3.1,1.3,3.4h2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 11.5,
    y: 90.8,
    width: 77,
    height: 28.3,
    rx: 3.6,
    ry: 3.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.4,0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0,0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.8,0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100,60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1.5,61.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.5,107.8c1.8,0,3.6-.2,5.4-.2,0-2.9,2.2-5.3,4.8-5.3V7c-2.7,0-4.8-2.4-4.8-5.3-14.1-.7-28.7-1.1-43.9-1.1S20.1,1,6.1,1.7c0,.4,0,2.2-1.4,3.8-.5.6-1.2,1.1-2,1.3-.6.2-1.1.2-1.4.2v95.3c.3,0,.9,0,1.4.2.8.3,1.4.7,2,1.3,1.4,1.5,1.4,3.4,1.4,3.8,1.8,0,3.6.2,5.4.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProficiencyFrame);
export default __webpack_public_path__ + "static/media/proficiency_frame.b05db49f545013c21be256fa1c9b0083.svg";
export { ForwardRef as ReactComponent };